<div class="sidenav bg-paper">
  <div class="sidenav__hold">
    <div class="brand-area">
      <div class="flex items-center justify-center brand">
        <img src="https://prysmaticlabs.com/assets/Prysm.svg" alt="company-logo"/>
        <span class="brand__text">Prysm Web</span>
      </div>
    </div>
    <div class="scrollbar-container scrollable position-relative ps">
      <div class="navigation">
        <div *ngFor="let link of links">
          <a *ngIf="!link.children && !link.externalUrl"
            class="nav-item active"
            [routerLink]="link.path"
            routerLinkActive="active"
          >
            <button mat-button class="nav-button">
              <div class="content flex items-center">
                <mat-icon aria-hidden="false" class="ml-1" aria-label="Example home icon">
                  {{link.icon}}
                </mat-icon>
                <span class="ml-6">
                  {{link.name}}
                </span>
              </div>
            </button>
          </a>
          <a *ngIf="!link.children && link.externalUrl"
             class="nav-item"
             [href]="link.externalUrl"
             target="_blank"
          >
            <button mat-button class="nav-button">
              <div class="content flex items-center">
                <mat-icon aria-hidden="false" class="ml-1" aria-label="Example home icon">
                  {{link.icon}}
                </mat-icon>
                <span class="ml-6">
                  {{link.name}}
                </span>
              </div>
            </button>
          </a>
          <app-sidebar-expandable-link
            *ngIf="link.children"
            [link]="link"
          >
          </app-sidebar-expandable-link>
        </div>
        <app-version></app-version>
      </div>
    </div>
  </div>
</div>
